// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__7HuNt","contacts_wrapper":"Contacts_contacts_wrapper__DTGnQ","info":"Contacts_info__J1QBR","contacts_list":"Contacts_contacts_list__TyBkc"};